var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12V5.749C20.0001 5.67006 19.9845 5.59189 19.9543 5.51896C19.9241 5.44603 19.8798 5.37978 19.824 5.324L16.676 2.176C16.5636 2.06345 16.4111 2.00014 16.252 2H4.6C4.44087 2 4.28826 2.06321 4.17574 2.17574C4.06321 2.28826 4 2.44087 4 2.6V21.4C4 21.5591 4.06321 21.7117 4.17574 21.8243C4.28826 21.9368 4.44087 22 4.6 22H11M8 10H16M8 6H12M8 14H11M20.5 20.5L22.5 22.5",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1667 3V5.93684C16.1667 6.1211 16.2404 6.29781 16.3717 6.4281C16.503 6.55838 16.681 6.63158 16.8667 6.63158H19.8333M14 17.5263C14 18.4476 14.3687 19.3311 15.0251 19.9826C15.6815 20.634 16.5717 21 17.5 21C18.4283 21 19.3185 20.634 19.9749 19.9826C20.6313 19.3311 21 18.4476 21 17.5263C21 16.605 20.6313 15.7215 19.9749 15.07C19.3185 14.4186 18.4283 14.0526 17.5 14.0526C16.5717 14.0526 15.6815 14.4186 15.0251 15.07C14.3687 15.7215 14 16.605 14 17.5263Z",
    stroke: "#939393",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7998 17.6667C16.4998 16.1111 18.5998 16.1111 19.2998 17.6667",
    stroke: "#939393",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5496 18.444C17.473 18.444 17.3972 18.4289 17.3264 18.3996C17.2556 18.3703 17.1913 18.3273 17.1372 18.2732C17.083 18.219 17.04 18.1547 17.0107 18.0839C16.9814 18.0131 16.9663 17.9373 16.9663 17.8607C16.9663 17.7841 16.9814 17.7082 17.0107 17.6374C17.04 17.5667 17.083 17.5024 17.1372 17.4482C17.1913 17.394 17.2556 17.3511 17.3264 17.3217C17.3972 17.2924 17.473 17.2773 17.5496 17.2773C17.7044 17.2773 17.8527 17.3388 17.9621 17.4482C18.0715 17.5576 18.133 17.706 18.133 17.8607C18.133 18.0154 18.0715 18.1638 17.9621 18.2732C17.8527 18.3826 17.7044 18.444 17.5496 18.444Z",
    fill: "#939393",
    stroke: "#939393",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileStatus);
export default __webpack_public_path__ + "static/media/profile-status.c2e287e214c7457d7b49b589a9dcdf0f.svg";
export { ForwardRef as ReactComponent };